import { IonPage, IonContent, IonToggle } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import './DocsPage.css';
import ReactMarkdown from 'react-markdown';

const menuItems = [
  { id: 'intro', label: 'Intro', file: 'intro.md' },
  { id: 'inputs', label: 'Inputs', file: 'inputs.md' },
  { id: 'outputs', label: 'Outputs', file: 'outputs.md' },
  { id: 'estimator', label: 'Estimator', file: 'estimator.md' },
  { id: 'classifier', label: 'Classifier', file: 'classifier.md' },
  { id: 'scoring system', label: 'Scoring System', file: 'scoring.md' },
  { id: 'about', label: 'Über die Docs', file: 'about.md' },
];

function getLangFolder() {
  const lang = navigator.language || 'en';
  if (lang.startsWith('de')) return 'de';
  return 'en';
}

const DocsPage: React.FC = () => {
  const [selected, setSelected] = useState(menuItems[0].id);
  const [markdown, setMarkdown] = useState('');
  const [dark, setDark] = useState(true);
  const [langFolder, setLangFolder] = useState(getLangFolder());

  useEffect(() => {
    setLangFolder(getLangFolder());
  }, []);

  useEffect(() => {
    const file = menuItems.find((item) => item.id === selected)?.file;
    if (file) {
      fetch(`/docs/${langFolder}/${file}`)
        .then((res) => res.text())
        .then(setMarkdown)
        .catch(() => setMarkdown('Fehler beim Laden des Inhalts.'));
    }
  }, [selected, langFolder]);

  useEffect(() => {
    document.body.classList.toggle('docs-dark', dark);
    return () => document.body.classList.remove('docs-dark');
  }, [dark]);

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="docs-theme-toggle-absolute">
          <IonToggle
            checked={dark}
            onIonChange={e => setDark(e.detail.checked)}
            mode="md"
            color="light"
            aria-label="Theme wechseln"
          />
          <span className="docs-theme-toggle-label">DARK MODE</span>
        </div>
        <div className="docs-page-container">
          <aside className="docs-menu">
            <nav>
              <ul>
                {menuItems.map((item) => (
                  <li
                    key={item.id}
                    className={selected === item.id ? 'active' : ''}
                    onClick={() => setSelected(item.id)}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            </nav>
          </aside>
          <main className="docs-content">
            <ReactMarkdown>{markdown}</ReactMarkdown>
          </main>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default DocsPage;
